export enum CurrencyType {
    Usd = 'usd',
    Vnd = 'vnd',
}
